export const FRIENDS_PAGE_LIMIT = 8
export const NEW_REFERRAL_THRESHOLD_HOURS = 24
